import { render, staticRenderFns } from "./BuddleOrder.vue?vue&type=template&id=73675734&scoped=true"
import script from "./BuddleOrder.vue?vue&type=script&lang=js"
export * from "./BuddleOrder.vue?vue&type=script&lang=js"
import style0 from "./BuddleOrder.vue?vue&type=style&index=0&id=73675734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73675734",
  null
  
)

export default component.exports